import Lucene from 'services/lucene';

export default class FolderDetailsController {
    /** @ngInject */
    constructor(EventEmitter, DialogService) {
        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
    }

    $onInit() {
        this.folderName = this.folder.name;
        this.searchQuery = Lucene.convertFoldersToLuceneCompatible([this.folder.id]);
    }

    save() {
        this.onSaved(
            this.eventEmitter({
                folder: this.folder
            })
        );
        this.folderName = this.folder.name;
    }

    cancel() {
        this.onEditCancelled();
    }

    showDeleteConfirmation() {
        this.DialogService.confirm({
            title: 'Delete Folder?',
            textContent: `Do you really want to delete folder "${this.folderName}"?`,
            ariaLabel: 'delete-folder',
            ok: 'Delete',
            cancel: 'Cancel'
        }).then(() => {
            this.onDeleted(
                this.eventEmitter({
                    folder: this.folder
                })
            );
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folder-details/folder-details.controller.js